import { RJSFSchema, UiSchema } from '@rjsf/utils';
import { SustainabilitySchemaTranslator } from 'src/integration/ddm/translation/SustainabilitySchemaTranslator';
import { logger } from 'src/logger';
import { CaseCreationStaticSchema } from 'src/components/Forms/CreateCase/CreateCaseSchema';
import { ProductSafetySchemaTranslator } from 'src/integration/ddm/translation/ProductSafetySchemaTranslator';
import { DSAOOCSSchemaTranslator } from 'src/integration/ddm/translation/DSAOOCSSchemaTranslator';
import { CSAMSchemaTranslator } from './translation/CSAMSchemaTranslator';
import { PaymentServicesComplaintSchemaTranslator } from './translation/PaymentServicesComplaintTranslator';
import { AccountId } from 'src/constants/GlobalConstants';

export interface SchemaAttributes {
  schemaKey: string;
  coreSchema: RJSFSchema;
  uiSchema: UiSchema;
  caseSummarySchema: RJSFSchema;
  createCaseStaticSchema: CaseCreationStaticSchema;
  bundles: any;
}

export interface SchemaTranslator {
  translateCoreSchema: () => RJSFSchema;
  translateUiSchema: () => UiSchema;
  translateCaseSummarySchema: () => RJSFSchema;
  translateCreateCaseStaticSchema: () => CaseCreationStaticSchema;
}

/**
 Replace placeholders in schemas to localized strings
 */
const DDMSchemaTranslationProvider = (
  schemaAttributes: SchemaAttributes,
): SchemaTranslator => {
  if (AccountId.SUSTAINABILITY.includes(schemaAttributes.schemaKey)) {
    const translationProvider = new SustainabilitySchemaTranslator(
      schemaAttributes,
    );

    logger.info(
      'Loading SustainabilitySchemaTranslatorProvider. Check log context for additional info:',
      { translationProvider },
    );

    return translationProvider;
  } else if (
    AccountId.DSA_OUT_OF_COURT_SETTLEMENT.includes(schemaAttributes.schemaKey)
  ) {
    const translationProvider = new DSAOOCSSchemaTranslator(schemaAttributes);

    logger.info(
      'Loading DSAOOCSSchemaTranslator. Check log context for additional info:',
      { translationProvider },
    );

    return translationProvider;
  } else if (AccountId.PRODUCT_SAFETY.includes(schemaAttributes.schemaKey)) {
    const translationProvider = new ProductSafetySchemaTranslator(
      schemaAttributes,
    );

    logger.info(
      'Loading ProductSafetySchemaTranslatorProvider. Check log context for additional info:',
      { translationProvider },
    );

    return translationProvider;
  } else if (AccountId.CSAM.includes(schemaAttributes.schemaKey)) {
    const translationProvider = new CSAMSchemaTranslator(schemaAttributes);

    logger.info(
      'Loading CSAMSchemaTranslator. Check log context for additional info:',
      { translationProvider },
    );
    return translationProvider;
  } else if (
    AccountId.PAYMENTS_SERVICES_COMPLAINT.includes(schemaAttributes.schemaKey)
  ) {
    const translationProvider = new PaymentServicesComplaintSchemaTranslator(
      schemaAttributes,
    );
    logger.info(
      'Loading PaymentServicesComplaintSchemaTranslator. Check log context for additional info:',
      { translationProvider },
    );

    return translationProvider;
  }

  return {
    translateCoreSchema: () => schemaAttributes?.coreSchema,
    translateUiSchema: () => schemaAttributes?.uiSchema,
    translateCaseSummarySchema: () => schemaAttributes?.caseSummarySchema,
    translateCreateCaseStaticSchema: () =>
      schemaAttributes?.createCaseStaticSchema,
  };
};

export default DDMSchemaTranslationProvider;
